import React from "react";
import { FacilitySelectBtn } from "./facilitySelectBtn";
import type { IBurialAdd } from "service/interface/burial";

interface Props {
  data: IBurialAdd;
  setData: React.Dispatch<React.SetStateAction<IBurialAdd>>;
}

export function FacilityInfoTable({ data, setData }: Props) {
  const facilities: {
    id:
      | "isRestaurant"
      | "isSnack"
      | "isParking"
      | "isWaitingRoom"
      | "isHandicapped";
    name: string;
  }[] = [
    {
      id: "isRestaurant",
      name: "식당",
    },
    { id: "isSnack", name: "매점" },
    { id: "isParking", name: "주차장" },
    { id: "isWaitingRoom", name: "유족대기실" },
    { id: "isHandicapped", name: "장애인 편의시설" },
  ];

  const handleSelectFacility = (
    label:
      | "isRestaurant"
      | "isSnack"
      | "isParking"
      | "isWaitingRoom"
      | "isHandicapped",
  ) => {
    setData((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  return (
    <div className="mb-[64px]">
      <div className="mb-[16px] flex items-center gap-[22px]">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          편의시설 정보
        </p>
        <p className="m-0 text-[18px] font-semibold text-[#aaa]">
          가능한 시설을 선택해주세요.
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="mt-[24px] flex items-center gap-[8px]">
          {facilities.map((facility, idx) => (
            <FacilitySelectBtn
              key={idx}
              label={facility}
              isSelected={data[facility.id]}
              onClick={handleSelectFacility}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
